import React from 'react';
import classNames from 'classnames';
import { IconButton } from 'components/buttons/IconButton';
import { LIST_ITEM_CLASS_NAME } from 'components/lists/ListItem';
import './ColorPaletteControlButtons.less';

export interface IColorPaletteControlButtonsProps extends React.HTMLProps<{}> {
  colors: string[];
  selectedIndex: number;
  onAdd?: React.MouseEventHandler;
  onEdit: React.MouseEventHandler;
  onMoveUp: React.MouseEventHandler;
  onMoveDown: React.MouseEventHandler;
  onRemove: React.MouseEventHandler;
}

const getClassName = (className?: string) => classNames('dp-color-palette-controls', className);
const getMoveUpClass = (isFirst?: boolean) =>
  classNames(`${LIST_ITEM_CLASS_NAME}__up`, {
    'dp-color-palette-controls__button--disabled': isFirst,
  });
const getMoveDownClass = (isLast?: boolean) =>
  classNames(`${LIST_ITEM_CLASS_NAME}__down`, {
    'dp-color-palette-controls__button--disabled': isLast,
  });

/**
 * Button controls
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function ColorPaletteControlButtons({
  className,
  colors,
  onAdd,
  onEdit,
  onMoveDown,
  onMoveUp,
  onRemove,
  selectedIndex,
}: IColorPaletteControlButtonsProps) {
  const noSelection = selectedIndex < 0 || !colors.length;
  const isFirst = selectedIndex === 0;
  const isLast = selectedIndex === colors.length - 1;

  return (
    <div className={getClassName(className)}>
      {onAdd && <IconButton iconClassName={`${LIST_ITEM_CLASS_NAME}__add`} onClick={onAdd} iconSize="small" />}
      <IconButton
        title="Edit"
        className="dp-color-palette-controls__button"
        iconClassName={`${LIST_ITEM_CLASS_NAME}__edit`}
        onClick={onEdit}
        iconSize="small"
        disabled={noSelection}
      />
      <IconButton
        title="Move Up"
        className="dp-color-palette-controls__button"
        iconClassName={getMoveUpClass(isFirst)}
        onClick={onMoveUp}
        iconSize="small"
        disabled={noSelection || isFirst}
      />
      <IconButton
        title="Move Down"
        className="dp-color-palette-controls__button"
        iconClassName={getMoveDownClass(isLast)}
        onClick={onMoveDown}
        iconSize="small"
        disabled={noSelection || isLast}
      />
      <IconButton
        title="Remove"
        className="dp-color-palette-controls__button"
        iconClassName={`${LIST_ITEM_CLASS_NAME}__remove`}
        onClick={onRemove}
        iconSize="small"
        disabled={noSelection}
      />
    </div>
  );
}
